import React from "react";
import { NavDropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useNotifications } from "../../contexts/notificationContext";
import NotificationModel from "../../models/NotificationModel";
import DataService from '../../services/data.service';
import { Result } from "../../types/Result";
import { useAuth } from "./../../contexts/authContext";
import FormatUtils from './../../utils/FormatUtils.js';

interface IProps {
    notification: NotificationModel
    onNotificationChanged: () => void
}

const WorkflowTaskNavDropdownItem: React.FC<IProps> = ({ notification, onNotificationChanged }) => {
    const { handleResult, handleException } = useNotifications();
    const navigate = useNavigate()

    const text = notification.text;
    let title = notification.title;

    const { user } = useAuth();

    let locale = 'nl-NL'
    if (user && user.language)
        locale = user.language;

    let dueOnClassName = 'pull-right';

    const dueOnFormatted = new FormatUtils().formatDateTimeStringFromLocale(notification.createdOn, locale);
    const taskUrl = '/plm' + notification.actionUrl;

    const fontWeight = notification.readOn  ? 'normal' : 'bolder'

    function onClick() {
        DataService
            .put<Result>(`api/v1/Notifications/${notification.id}/read`, undefined)
            .then(response => {
                if (!response.isSuccesful)
                    handleResult(response)

                onNotificationChanged()
                navigate(taskUrl)
            })
            .catch(e => handleException(e))
    }

    function OnDeleteClick(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
        e.preventDefault();

        DataService
            .delete('api/v1/Notifications/', notification.id)
            .then(response => {
                if (!response.isSuccesful)
                    handleResult(response)

                onNotificationChanged()

            })
            .catch(e => handleException(e))
    }

    return (
        <NavDropdown.Item style={{width:500}}>
            <i className="pe-7s-note2" onClick={onClick} /><span className={dueOnClassName}>{dueOnFormatted} <i className="fa fa-trash" style={{ marginRight: 10, color: 'red' }} onClick={OnDeleteClick} /></span>
            <div onClick={onClick}>
                <div style={{ fontWeight: fontWeight }}>
                    <span>{title}</span>
                </div>
                <div style={{ marginLeft: 46, width: 300, whiteSpace: 'normal', fontWeight: fontWeight }}>
                    {notification.createdByUser.thumbnailUrl && (<div className='thumbnail pull-right'><img height='32' src={notification.createdByUser.thumbnailUrl} /></div>)}
                    {text}
                </div>
            </div>
        </NavDropdown.Item>
    )
}
export default WorkflowTaskNavDropdownItem;